import { useEffect } from "react";

import { useCustomUtilities } from "@/components/builder/utils/tailwindConfig/hooks";

import { useFormFieldContext } from "../context";

export function useFormConsentUtilities() {
  const { field: { field_component } } = useFormFieldContext()
  const { value: utilities, setValue: setUtilities } = useCustomUtilities()

  useEffect(() => {
    if (field_component !== 'checkbox_instructions_text') {
      return;
    }

    const updated = !ARBITRARY_VARIANTS.some(variant => utilities.includes(variant))
    if (updated) {
      setUtilities([...utilities, ...ARBITRARY_VARIANTS])
    }
  }, [field_component, utilities, setUtilities])
}

const ARBITRARY_VARIANTS = [
  '[[data-status=error]_&]',
  '[[data-status=checked]_&]',
]
